import axios from 'axios'

const YURL_ENDPOINT = `${process.env.KONG_URI}/yurl`

interface Metadata {
  [key: string]: string
}

export default function createYurl(
  fileName: string,
  metadata: Metadata,
  token: string,
  keyPrefix: string,
  acl = 'private'
) {
  const headers = {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
  }
  const body = {
    acl,
    keyPrefix,
    fileName,
    metadata
  }

  return axios.post(YURL_ENDPOINT, body, { headers })
}
